import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { DxDataGridComponent } from "devextreme-angular";
import { EmployeePortalService } from '../../_api/services/employee-portal.service';
import { LanguageService } from '../../../../shared/services/language.service';

@Component({
  selector: 'app-employee-aml-week',
  templateUrl: './employee-aml-week.component.html',
  styleUrls: ['./employee-aml-week.component.css']
})
export class EmployeeAmlWeekComponent implements OnInit {

  @ViewChild(DxDataGridComponent, {static: false}) dataGrid: DxDataGridComponent;
  dataSource: any;
  columns: any[];
  summary: any;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(employee-portal.component) to show load indicator  
  from: string;
  to: string;
  titleWeekFromTo = this.languageService.LNG("Label.Week") + " " + this.languageService.LNG("Label.From") + "-" + this.languageService.LNG("Label.To");
  weeks = [];
  @Input() selectedEmployeeId = -1;
  
  constructor(private employeePortalService: EmployeePortalService, public languageService: LanguageService) {
  }

  ngOnInit() {
    let fromDate = moment().startOf('isoWeek');
    this.from = fromDate.format("DD.MM.YYYY");
    this.to = fromDate.add(4, 'weeks').format("DD.MM.YYYY");//add 4 weeks to get 5 in total

    this.loadAmlWeekEmployee();
  }

  loadAmlWeekEmployee() {
    this.loading.emit(true);
    if(this.selectedEmployeeId != undefined) {
      this.employeePortalService.getAmlWeekEmployees(this.from, this.to, this.selectedEmployeeId).subscribe((result: any) => {
        this.loading.emit(false);
        if (result.IsSuccess) {
          this.weeks = result.Data.Weeks;
          let amlWeekEmployees = result.Data.AmlWeekEmployeeListItems;
          this.addColumnsDataGrid();
          this.dataSourceRows(amlWeekEmployees);
        }
      });
    }
  }

  addColumnsDataGrid() {
    this.columns = [];
    this.columns.push({ dataField: 'EmployeeNumber', caption: this.languageService.LNG('Label.Empl.No') });
    this.columns.push({ dataField: 'FullName', caption: this.languageService.LNG('Label.Name'), width: 250 });
    this.columns.push({ dataField: 'DepartmentName', caption: this.languageService.LNG('Label.Department') });
    this.columns.push({ dataField: 'GroupName', caption: this.languageService.LNG('Label.Group'), allowFiltering: false });
    this.columns.push({ dataField: 'WeekLimitSevenDays', caption: this.languageService.LNG('Label.WeekLimit'), allowFiltering: false, format: {
      type: "fixedPoint",
      precision: 2
    } });
    // this.columns.push({ dataField: 'LimitFourWeeks', caption: this.languageService.LNG('Label.LimitFourWeeks'), allowFiltering: false, format: {
    //   type: "fixedPoint",
    //   precision: 2
    // } });
    // this.columns.push({ dataField: 'LimitOneYear', caption: this.languageService.LNG('Label.LimitOneYear'), allowFiltering: false, format: {
    //     type: "fixedPoint",
    //     precision: 2
    //   }
    // });
    let summaryTotalItems = [];
    this.weeks.forEach(w => {
        this.columns.push({ dataField: w.WeekNoYear, caption: w.WeekYearToString, allowEditing: false, allowFiltering: false, alignment: "right", format: {
          type: "fixedPoint",
          precision: 2
        }
       });
       summaryTotalItems.push({ name: "customSumHoursDecimal" + w.WeekNoYear, summaryType: "custom", displayFormat: "{0}", showInColumn: w.WeekNoYear});
    });
    this.columns.push({ dataField: "Sum", caption: this.languageService.LNG("Label.Sum"), allowFiltering: false, format: { type: "fixedPoint", precision: 2}});
    summaryTotalItems.push({ name: "customSumDecimal", summaryType: "custom", displayFormat: "{0}", showInColumn: "Sum"});
    this.columns.push({ dataField: "Avg", caption: this.languageService.LNG("Label.Average"), allowFiltering: false, format: { type: "fixedPoint", precision: 2}});
    this.summary = {
      totalItems: summaryTotalItems,
      calculateCustomSummary: (options) =>  {
          // Calculating "customSummary1"
          if (options.name) {
            if (options.name == "customSumDecimal") {
              switch(options.summaryProcess) {
                case "start":
                    // Initializing "totalValue" here
                    options.totalValue = 0;
                    break;
                case "calculate":
                    if (options.value.Sum > 0)
                    {
                      options.totalValue += options.value.Sum;
                    }
                    // Modifying "totalValue" here
                    break;
                case "finalize":
                    // // Assigning the final value to "totalValue" here
                    let rounded = (Math.round(options.totalValue * 100) / 100).toFixed(2);
                    // let min = (options.totalValue / 60) % 60;
                    options.totalValue = rounded.replace(".", ",");
                    break;
              }
            }
            else {
              this.weeks.forEach(w => {
                if (options.name == "customSumHoursDecimal" + w.WeekNoYear) {
                  switch(options.summaryProcess) {
                    case "start":
                        // Initializing "totalValue" here
                        options.totalValue = 0;
                        break;
                    case "calculate":
                        if (options.value[w.WeekNoYear] > 0)
                        {
                          options.totalValue += options.value[w.WeekNoYear];
                        }
                        // Modifying "totalValue" here
                        break;
                    case "finalize":
                        // // Assigning the final value to "totalValue" here
                        let rounded = (Math.round(options.totalValue * 100) / 100).toFixed(2);
                        // let min = (options.totalValue / 60) % 60;
                        options.totalValue = rounded.replace(".", ",");
                        break;
                  }
                }
              });
            }
          }
      }
    }
  }

  dataSourceRows(amlWeekEmployees) {
    this.dataSource = [];
    amlWeekEmployees.forEach(row => {
      let dataSourceRow = {};
      dataSourceRow["EmployeeId"] = row.EmployeeId;
      dataSourceRow["EmployeeNumber"] = row.EmployeeNumber;
      dataSourceRow["FullName"] = row.FullName;
      dataSourceRow["DepartmentName"] = row.DepartmentName;
      dataSourceRow["GroupName"] = row.GroupName;
      dataSourceRow["WeekLimitSevenDays"] = row.WeekLimitSevenDaysHours;
      // dataSourceRow["LimitFourWeeks"] = row.LimitFourWeeksHours;
      // dataSourceRow["LimitOneYear"] = row.LimitOneYearHours;
      for (let i = 0; i < this.weeks.length; i++) {
        var w = this.weeks[i];
        if (row["AmlWeeks"] != null) {
          var amlWeeks = row["AmlWeeks"];
          let amlWeek = amlWeeks.find(amlW => amlW.WeekNo == w["WeekNo"] && amlW.Year == w["Year"]);
          if (amlWeek) {
            dataSourceRow[w["WeekNoYear"]] = amlWeek.CurrentAmlValueHours;
          }
        }
      }
      dataSourceRow["Sum"] = row.Sum;
      dataSourceRow["Avg"] = row.Avg;
      this.dataSource.push(dataSourceRow);
    });
  }

  dateChanged(dateInterval: any) {
    this.from = dateInterval.FromDate.format("DD.MM.YYYY");
    this.to = dateInterval.ToDate.format("DD.MM.YYYY");
    this.loadAmlWeekEmployee();
  }

  calculateCustomSummary(options) {
    if (options.name == "customSumHoursDecimal") {
      switch(options.summaryProcess) {
          case "start":
              // Initializing "totalValue" here
              options.totalValue = 0;
              break;
          case "calculate":
              if (options.value.Seconds > 0)
              {
                parseFloat
                options.totalValue += options.value.Seconds;
              }
              // Modifying "totalValue" here
              break;
          case "finalize":
              
              // Assigning the final value to "totalValue" here
              let hours = options.totalValue / 3600;
              let rounded = (Math.round(hours * 100) / 100).toFixed(2);
              // let min = (options.totalValue / 60) % 60;
              options.totalValue = rounded.replace(".", ",");
              break;
      }
    }
  }
}
